// src/api/dattoApi.js
// Datto RMM API client — reads from backend blob cache

import apiClient from "./apiClient";

export async function getDattoStatus() {
  const r = await apiClient.get("/api/datto/status");
  return r.data;
}

export async function triggerDattoSync(managedNames = []) {
  const r = await apiClient.post("/api/datto/sync", { managedNames });
  return r.data;
}

export async function getDattoData() {
  const r = await apiClient.get("/api/datto/data");
  return r.data;
}

export async function getDattoSites() {
  const r = await apiClient.get("/api/datto/sites");
  return r.data;
}

export async function getDattoAlerts(siteUid) {
  const r = await apiClient.get("/api/datto/alerts", { params: siteUid ? { siteUid } : {} });
  return r.data;
}
